import PropTypes from 'prop-types';

import { EditDietaryPreferencesModule } from './EditDietaryPreferencesModule';
import EditIFPlansModule from './EditIFPlansModule';
import EditPlansV1Module from './EditPlansV1Module';
import EditPlansV2Module from './EditPlansV2Module';

function EditPlansModule({ account, isDietaryPreferences, isImperfectLegacy, isPlansV2, setError, setIsEditing }) {
    if (isDietaryPreferences)
        return <EditDietaryPreferencesModule account={account} setIsEditing={setIsEditing} setError={setError} />;
    if (isImperfectLegacy)
        return <EditIFPlansModule account={account} setIsEditing={setIsEditing} setError={setError} />;
    if (isPlansV2) return <EditPlansV2Module account={account} setIsEditing={setIsEditing} setError={setError} />;

    return <EditPlansV1Module account={account} setIsEditing={setIsEditing} setError={setError} />;
}

EditPlansModule.propTypes = {
    account: PropTypes.shape({}),
    isDietaryPreferences: PropTypes.bool.isRequired,
    isImperfectLegacy: PropTypes.bool.isRequired,
    isPlansV2: PropTypes.bool.isRequired,
    setError: PropTypes.func.isRequired,
    setIsEditing: PropTypes.func.isRequired,
};

EditPlansModule.defaultProps = {
    account: {},
};

export default EditPlansModule;
